import { cosmos } from "./client";
import { parseTransactionDetails } from "./parseTransactionDetails";
import { ThornodeTransactionDetails } from "./types";

export const getTransactionDetails = async (txHash: string | undefined) => {
  if (!txHash) return;

  const { data: transactionDetails } = await cosmos.get<ThornodeTransactionDetails>(
    `tx/v1beta1/txs/${txHash}`,
  );

  if (!transactionDetails) return;

  return parseTransactionDetails(transactionDetails);
};
